// @ts-ignore
/* eslint-disable */
import { request } from '@umijs/max';
import { notification } from 'antd';

/** 获取当前的用户 GET /api/current_user */
export async function currentUser(options?: { [key: string]: any }) {
  const response = await request<{
    data: API.CurrentUser;
  }>('/api/user/current_user', {
    method: 'GET',
    ...(options || {}),
  });
  return response.data
}

export async function outLogin(options?: { [key: string]: any }) {
  return request<Record<string, any>>('/api/loginout', {
    method: 'POST',
    ...(options || {}),
  });
}

export async function login(body: API.LoginParams, options?: { [key: string]: any }) {
  const response = await request<API.LoginResult>('/api/login', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
  if (response.retcode !== 0) {
    throw new Error(response.message || 'An error occurred');
  }
  return response
}

/** 此处后端没有提供注释 GET /api/notices */
export async function getNotices(options?: { [key: string]: any }) {
  return request<API.NoticeIconList>('/api/notices', {
    method: 'GET',
    ...(options || {}),
  });
}

/** 获取规则列表 GET /api/rule */
export async function rule(
  params: {
    // query
    /** 当前的页码 */
    current?: number;
    /** 页面的容量 */
    pageSize?: number;
  },
  options?: { [key: string]: any },
) {
  return request<API.RuleList>('/api/rule', {
    method: 'GET',
    params: {
      ...params,
    },
    ...(options || {}),
  });
}

/** 更新规则 PUT /api/rule */
export async function updateRule(options?: { [key: string]: any }) {
  return request<API.RuleListItem>('/api/rule', {
    method: 'POST',
    data: {
      // method: 'update',
      ...(options || {}),
    },
  });
}

/** 新建规则 POST /api/rule */
export async function addRule(options?: { [key: string]: any }) {
  return request<API.RuleListItem>('/api/rule', {
    method: 'POST',
    data: {
      method: 'post',
      ...(options || {}),
    },
  });
}

/** 删除规则 DELETE /api/rule */
export async function removeRule(options?: { [key: string]: any }) {
  return request<Record<string, any>>('/api/rule', {
    method: 'POST',
    data: {
      method: 'delete',
      ...(options || {}),
    },
  });
}

export async function visitRecordSearch(
  data: {
    // query
    /** 当前的页码 */
    current?: number;
    /** 页面的容量 */
    pageSize?: number;
    /** 日期范围 */
    date_range?: [number, number];
    [key: string]: any; // 支持其他额外的搜索参数
  },
  options?: { [key: string]: any },
) {
  const { date_range, current, pageSize, ...restData } = data;
  const processedDatas = {
    ...restData,
    pageno: current || 1,
    count: pageSize || 20,
  };

  if (date_range && date_range.length === 2) {
    if (date_range[0] != null && date_range[0] != "undefined") {
      processedDatas.begin_ctime = Math.floor(date_range[0] / 1000);
    }
    if (date_range[1] != null && date_range[1] != "undefined") {
      processedDatas.end_ctime = Math.floor(date_range[1] / 1000);
    }
  }

  const response = await request<API.VisitRecordList>('/api/visit_record/search', {
    method: 'POST',
    data: processedDatas,
    ...(options || {}),
  });
  if (response.retcode !== 0) {
    notification.error({
      message: '请求失败',
      description: response.message || '发生未知错误',
    });
    throw new Error(response.message || 'An error occurred');
  }

  return {
    data: response.data.list,
    total: response.data.total,
    pageSize: response.data.count,
    success: response.retcode === 0,
    message: response.message,
  };
}

export async function UserSearch(
  params: {
    // query
    /** 当前的页码 */
    current?: number;
    /** 页面的容量 */
    pageSize?: number;
    [key: string]: any;
  },
  sort: Record<string, 'ascend' | 'descend'>,
  filter: Record<string, any>,
  options?: { [key: string]: any },
) {
  let order_by: string | undefined;

  const sortField = Object.keys(sort)[0];
  const sortOrder = sort[sortField];

  // ✅ 拼接 order_by 参数（带负号表示降序）
  if (sortField && sortOrder) {
    order_by = sortOrder === 'ascend' ? sortField : `-${sortField}`;
  }

  const response = await request<API.VisitRecordList>('/api/user/search', {
    method: 'GET',
    params: {
      pageno: params.current || 1,
      count: params.pageSize || 20,
      ...params,
      order_by,
    },
    ...(options || {}),
  });
  if (response.retcode !== 0) {
      notification.error({
        message: '请求失败',
        description: response.message || '发生未知错误',
      });
      throw new Error(response.message || 'An error occurred');
  }

  return {
    data: response.data.list,
    total: response.data.total,
    current: response.data.pageno,
    pageSize: response.data.count,
    success: response.retcode === 0,
    message: response.message,
  };

}

export async function ProjectSearch(
  params: {
    // query
    /** 当前的页码 */
    current?: number;
    /** 页面的容量 */
    pageSize?: number;
    [key: string]: any;
  },
  sort: Record<string, 'ascend' | 'descend'>,
  filter: Record<string, any>,
  options?: { [key: string]: any },
) {
  let order_by: string | undefined;

  const sortField = Object.keys(sort)[0];
  const sortOrder = sort[sortField];

  // ✅ 拼接 order_by 参数（带负号表示降序）
  if (sortField && sortOrder) {
    order_by = sortOrder === 'ascend' ? sortField : `-${sortField}`;
  }
  const response = await request<API.VisitRecordList>('/api/project/search', {
    method: 'GET',
    params: {
      pageno: params.current || 1,
      count: params.pageSize || 20,
      ...params,
      order_by,
    },
    ...(options || {}),
  });
  if (response.retcode !== 0) {
    notification.error({
      message: '请求失败',
      description: response.message || '发生未知错误',
    });
    throw new Error(response.message || 'An error occurred');
  }

  return {
    data: response.data.list,
    total: response.data.total,
    current: response.data.pageno,
    pageSize: response.data.count,
    success: response.retcode === 0,
    message: response.message,
  };

}

function get_response(response) {
  const response_data = {}
  if (response.retcode !== 0) {
    throw new Error(response.message || ' retcode: ' || response.retode);
  }
  return response_data
}

export async function createUserApi(options?: { [key: string]: any }) {
  const response = await request<API.UserCreateResultType>('/api/user/create', {
    method: 'POST',
    data: {
      ...(options || {}),
    },
  });
  if (response.retcode !== 0) {
    const errorMessage = response.message ? response.message : 'An error occurred';
    const errorCode = response.retcode !== undefined ? response.retcode : 'Unknown code';
    throw new Error(`${errorMessage} (retcode: ${errorCode})`);
  }

  const response_data = {
    "success": true,
  };
  return response_data
}

export async function createProjectApi(options?: { [key: string]: any }) {
  const response = await request<API.ProjectCreateResultType>('/api/project/create', {
    method: 'POST',
    data: {
      ...(options || {}),
    },
  });
  if (response.retcode !== 0) {
    const errorMessage = response.message ? response.message : 'An error occurred';
    const errorCode = response.retcode !== undefined ? response.retcode : 'Unknown code';
    throw new Error(`${errorMessage} (retcode: ${errorCode})`);
  }

  const response_data = {
    "success": true,
  };
  return response_data
}

export async function getMenus(options?: { [key: string]: any }) {
  const response = await request<API.MenuDataItem[]>('/api/user/current_user_menus', {
    method: 'GET',
    params: options,
  });

  return response.data;
}


export async function getWalletInfo(options?: { [key: string]: any }) {
  const response = await request<API.WalletInfo[]>('/api/wallet/wallet_detail', {
    method: 'GET',
    params: options,
  });

  return response.data;
}


export async function getWalletRecordList(options?: { [key: string]: any }) {
  const response = await request<API.WalletRecordList[]>('/api/wallet/wallet_record/search', {
    method: 'GET',
    params: options,
  });

  return {
    data: response.data.list,
    total: response.data.total,
    current: response.data.pageno,
    pageSize: response.data.count,
    success: response.retcode === 0,
    message: response.message,
  };
}


export async function getCloakWalletInfo(options?: { [key: string]: any }) {
  const response = await request<API.cloakWalletInfo[]>('/api/cloak_wallet/cloak_wallet_detail', {
    method: 'GET',
    params: options,
  });

  return response.data;
}


export async function getCloakWalletRecordList(options?: { [key: string]: any }) {
  const response = await request<API.CloakWalletRecordList[]>('/api/cloak_wallet/cloak_wallet_record/search', {
    method: 'GET',
    params: options,
  });

  return {
    data: response.data.list,
    total: response.data.total,
    current: response.data.pageno,
    pageSize: response.data.count,
    success: response.retcode === 0,
    message: response.message,
  };
}


export async function domainSearch(
  params: {
    // query
    /** 当前的页码 */
    current?: number;
    /** 页面的容量 */
    pageSize?: number;
    [key: string]: any;
  },
  sort: Record<string, 'ascend' | 'descend'>,
  filter: Record<string, any>,
  options?: { [key: string]: any },
) {
  let order_by: string | undefined;

  const sortField = Object.keys(sort)[0];
  const sortOrder = sort[sortField];

  // ✅ 拼接 order_by 参数（带负号表示降序）
  if (sortField && sortOrder) {
    order_by = sortOrder === 'ascend' ? sortField : `-${sortField}`;
  }

  const response = await request<API.DomainList>('/api/domain/search', {
    method: 'GET',
    params: {
      pageno: params.current || 1,
      count: params.pageSize || 20,
      ...params,
      order_by,
    },
    ...(options || {}),
  });
  if (response.retcode !== 0) {
    notification.error({
      message: '请求失败',
      description: response.message || '发生未知错误',
    });
    throw new Error(response.message || 'An error occurred');
  }

  return {
    data: response.data.list,
    total: response.data.total,
    current: response.data.pageno,
    pageSize: response.data.count,
    success: response.retcode === 0,
    message: response.message,
  };

}

export async function domainCheck(
  params: {
    domain_name?: string;
    tld_list?: string[]; // 修正类型为数组
    /** 当前的页码 */
    current?: number;
    /** 页面的容量 */
    pageSize?: number;
  },
  options?: { [key: string]: any },
) {
  const response = await request<API.DomainList>('/api/domain/check', {
    method: 'POST',
    data: { // 将参数放在 data 中
      pageno: params.current || 1,
      count: params.pageSize || 20,
      domain_name: params.domain_name,
      tld_list: params.tld_list,
    },
    ...(options || {}),
  });

  if (response.retcode !== 0) {
    notification.error({
      message: '请求失败',
      description: response.message || '发生未知错误',
    });
    throw new Error(response.message || 'An error occurred');
  }

  return {
    data: response.data.list,
    total: response.data.total,
    current: response.data.pageno,
    pageSize: response.data.count,
    success: response.retcode === 0,
    message: response.message,
  };
}

export async function domainCreate(options?: { [key: string]: any }) {
  const response = await request<API.DomainCreateType>('/api/domain/create', {
    method: 'POST',
    data: {
      ...(options || {}),
    },
  });
  if (response.retcode !== 0) {
    const errorMessage = response.message ? response.message : 'An error occurred';
    const errorCode = response.retcode !== undefined ? response.retcode : 'Unknown code';

    notification.error({
      message: '购买失败',
      description: response.message || '发生未知错误',
    });
    throw new Error(`${errorMessage} (retcode: ${errorCode})`);
  }

  const response_data = {
    "success": true,
  };
  notification.success({
    message: '购买成功',
    description: `域名 ${options.domain_name} 购买成功`,
  });
  return response_data
}


export async function removeProject(options?: { [key: string]: any }) {
  const response = await request<Record<string, any>>('/api/project/delete', {
    method: 'POST',
    data: {
      ...(options || {}),
    },
  });
  if (response.retcode !== 0) {
    notification.error({
      message: '请求失败',
      description: response.message || '发生未知错误',
    });
    throw new Error(response.message || 'An error occurred');
  }
  return response;
}

export async function scheduleProject(options?: { [key: string]: any }) {
  const response = await request<Record<string, any>>('/api/project/schedule', {
    method: 'POST',
    data: {
      ...(options || {}),
    },
  });
  if (response.retcode !== 0) {
    notification.error({
      message: '请求失败',
      description: response.message || '发生未知错误',
    });
    throw new Error(response.message || 'An error occurred');
  }
  return response;
}

export async function updateProject(options?: { [key: string]: any }) {
  const response = await request<API.RuleListItem>('/api/project/update', {
    method: 'POST',
    data: {
      ...(options || {}),
    },
  });
  if (response.retcode !== 0) {
    notification.error({
      message: '请求失败',
      description: response.message || '发生未知错误',
    });
    throw new Error(response.message || 'An error occurred');
  }
  return response;
}
